import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import V2Layout from "@/pages/v2/V2Layout";
import Seo from "@/components/Seo";

export default function V2Partners() {
  return (
    <V2Layout>
      <div data-testid="v2-partners">
        <Seo title="Partners · WHO" path="/v2/partners" description="WHO welcomes collaboration with veteran-serving organizations, community networks, researchers, funders, and government agencies." />
        <section className="py-16 lg:py-24 bg-white border-b border-borderSubtle">
          <div className="max-w-[760px] mx-auto px-5 lg:px-8">
            <p className="eyebrow text-gold-deep">Partners</p>
            <h1 className="mt-3 font-display font-black text-navy tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="v2-partners-title">
              Stronger Connections Begin With Collaboration.
            </h1>
            <div className="mt-6 space-y-4 text-slateSoft leading-relaxed">
              <p>
                WHO is seeking collaborative opportunities with service organizations, community networks,
                institutional funders, researchers, and government agencies to test and validate its planned
                approach — beginning with the planned Pittsburgh pilot.
              </p>
              <p className="font-semibold text-navy">
                &ldquo;WHO does not replace the organizations serving veterans. We are building an approach
                intended to help their work connect more effectively across the broader service ecosystem.&rdquo;
              </p>
              <p className="text-sm" data-testid="v2-directory-disclaimer">
                Inclusion in the WHO Discovery directory does not constitute a partnership, endorsement,
                referral agreement, or participation in WHO&rsquo;s coordinated services by the listed organization.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/v2/contact" className="inline-flex items-center gap-2 bg-gold hover:bg-gold-deep text-navy font-semibold px-6 py-3 rounded-md transition-colors" data-testid="v2-partners-cta">
                Start a conversation <ArrowRight className="w-4 h-4" />
              </Link>
              <a href="/assets/who-pilot-overview.pdf" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-navy/20 hover:border-gold text-navy font-semibold px-6 py-3 rounded-md transition-colors" data-testid="v2-partners-pdf-link">
                <FileText className="w-4 h-4" /> Pilot Overview (PDF)
              </a>
            </div>
          </div>
        </section>
      </div>
    </V2Layout>
  );
}
